/** "First Last" from a person's name parts. Missing parts are skipped, so the result is "" when both are empty. */
export function fullName(person) {
    return `${person.firstName ?? ""} ${person.lastName ?? ""}`.trim();
}
